<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="cancelSuccess"
            :alert="{
              title: 'Berhasil membatalkan rawat inap',
              type: 'success',
              content: `Rawat inap '${cancelItem.name}' berhasil dibatalkan dari sistem`,
            }"
          />
          <Alert
            v-if="cancelFailed"
            :alert="{
              title: 'Gagal membatalkan rawat inap',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Rawat inap '${cancelItem.name}' gagal dibatalkan`,
            }"
          />
          <Alert
            v-if="endSuccess"
            :alert="{
              title: 'Berhasil menyelesaikan rawat inap',
              type: 'success',
              content: `Rawat Inap '${endItem.name}' berhasil diselesaikan`,
            }"
          />
          <Alert
            v-if="endFailed"
            :alert="{
              title: 'Gagal menyelesaikan rawat inap',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Rawat Inap '${endItem.name}' gagal diselesaikan`,
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <router-link to="/ranap" class="nav-link active"
                    >Daftar Rawat Inap</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/ranap/kamar" class="nav-link"
                    >Daftar Kamar</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="status == item.filter"
                  />
                </b-tabs>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <!-- @each(input in filters) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
                <!-- @endeach -->
              </div>
              <div class="col-md-2">
                <!-- @each(input in sort) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
                <!-- @endeach -->
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="totalData > 10" value="25">25 data</option>
                      <option v-if="totalData > 25" value="50">50 data</option>
                      <option v-if="totalData > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <!-- :per-page="parseInt(perPage)"
            :filter="filter" -->
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :data="rows"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data rawat inap dengan status '${status.toLowerCase()} dan filter di atas'`,
                content:
                  'Mulai pemeriksaan baru dengan mengeklik tombol + Rawat Inap Baru di atas',
              }"
            />
            <Loading v-else />
            <!--             <br/>
            <p v-if="rows.length">Menampilkan {{rows.length>parseInt(perPage)?perPage:rows.length}} data dari total {{rows.length}} data</p>
<datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager> -->
            <br />
            <p v-if="totalData">
              Menampilkan {{ rows.length }} data dari total {{ totalData }} data
            </p>
            <b-pagination
              v-model="page"
              v-if="rows && rows.length"
              :total-rows="totalData"
              :per-page="parseInt(perPage)"
              v-on:click.native="(e) => goToPage(e)"
              align="center"
              first-number
              last-number
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="'cancel' + row.id + Math.random(1024)"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(row.id, `${row.no_rawat} | ${row.no_rm} - ${row.pasien.nama}`);
        }
      "
      style="display: none"
    ></button>
    <button
      v-for="row in rows"
      v-bind:key="'end' + row.id + Math.random(1024)"
      :id="'end' + row.id"
      @click="
        () => {
          end(row.id, `${row.no_rawat} | ${row.no_rm} - ${row.pasien.nama}`);
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan rawat inap berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal class="modal modal-confirm" id="modalEnd" size="lg">
      <template #modal-title>
        <p class="mb-1">Kepulangan Rawat Inap</p>
        <h5 class="mb-0 text-left text-primary">{{ endItem.name }}</h5>
      </template>
      <div class="container">
        <FormRow
          v-for="row in form"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => endChange(e)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btnendItem"
            class="btn btn-primary float-right"
            @click="
              () => {
                confirmEnd(endItem.id);
              }
            "
          >
            KONFIRMASI KEPULANGAN
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="$bvModal.hide('modalEnd')"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import { getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
import EmptyState from "@/components/EmptyState.vue";
let data = {
  title: "Rawat Inap",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Rawat Inap Baru",
      link: "/ranap/daftar",
      iconLeft: "add",
    },
  ],
  breadcrumb: [],
};
let tabs = [
  { title: "DIJADWALKAN", link: "#", filter: "DIJADWALKAN", active: true },
  { title: "BERLANGSUNG", link: "#", filter: "BERLANGSUNG" },
  { title: "SELESAI", filter: "SELESAI", link: "#selesai" },
  { title: "DIBATALKAN", filter: "DIBATALKAN", link: "#selesai" },
];

export let sorts = [
  {
    value: "desc",
    label: "Terbaru",
  },
  {
    value: "asc",
    label: "Terlama",
  },
];
let filters = {
  colnum: "",
  columns: [
    {
      label: "sejak tanggal",
      type: "date",
      placeholder: "Tanggal masuk",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart",
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal masuk",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd",
    },
    {
      label: "Kelas Kamar",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "kamar_ranap_kelas",
      mandatory: true,
      options: [
        { value: "VIP", label: "Kelas VIP" },
        { value: "I", label: "Kelas I" },
        { value: "II", label: "Kelas II" },
        { value: "III", label: "Kelas III" },
      ],
      colwidth: 3,
      id: "filterClass",
    },
    {
      label: "Kamar",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "kamar_ranap_nama",
      mandatory: true,
      options: [],
      colwidth: 3,
      id: "filterRoom",
    },
  ],
};
let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts,
      name: "orderBy",
    },
  ],
};
let doubleDigit = function(value) {
  let stringValue = String(value);
  if (value < 10) {
    stringValue = "0" + stringValue;
  }
  return stringValue;
};
let today = new Date();
// let time=today.getTime();
let time =
  doubleDigit(today.getHours()) +
  ":" +
  doubleDigit(today.getMinutes()) +
  ":" +
  doubleDigit(today.getSeconds());
//console.log(time);
let form = [
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "Tanggal Keluar",
        type: "date",
        placeholder: "Pilih tanggal keluar",
        name: "tgl_keluar",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "5",
      },
      {
        label: "Jam Keluar",
        type: "time",
        placeholder: "",
        name: "jam_keluar",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "Cara Keluar",
        type: "select",
        placeholder: "Pilih Cara Keluar",
        name: "cara_keluar",
        value: "Diijinkan Pulang",
        options: [
          { value: "Diijinkan Pulang", label: "Diijinkan Pulang" },
          { value: "Pulang Paksa", label: "Pulang Paksa" },
          { value: "Lari", label: "Lari" },
          { value: "Pindah RS Lain", label: "Pindah RS Lain" },
          { value: "Dirujuk", label: "Dirujuk" },
        ],
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Keadaan Keluar",
        type: "select",
        placeholder: "Pilih Keadaan Keluar",
        name: "keadaan_keluar",
        value: "Sembuh",
        options: [
          { value: "Sembuh", label: "Sembuh" },
          { value: "Membaik", label: "Membaik" },
          { value: "Belum Sembuh", label: "Belum Sembuh" },
          { value: "Mati <48 jam", label: "Mati <48 jam" },
          { value: "Mati >48 jam", label: "Mati >48 jam" },
          { value: "Lahir Mati", label: "Lahir Mati" },
        ],
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
    ],
  },
  {
    colnum: 1,
    class: "",
    columns: [
      {
        label: "Diagnosa Akhir",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan diagnosa akhir",
        name: "dgs_keluar",
        value: "",
        mandatory: true,
        additional: "",
        rows: 2,
      },
    ],
  },
  {
    colnum: 1,
    class: "",
    columns: [
      {
        label: "Prognosa",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan kajian pemeriksaan",
        name: "prognosa",
        value: "",
        mandatory: true,
        additional: "",
        rows: 2,
      },
    ],
  },
];
export default {
  name: "Ranap",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      form: form,
      cara_keluar: "Diijinkan Pulang",
      keadaan_keluar: "Sembuh",
      dgs_keluar: "",
      prognosa: "",
      tgl_keluar: "",
      jam_keluar: time,
      cancelSuccess: false,
      cancelFailed: false,
      endSuccess: false,
      endFailed: false,
      cancelItem: { id: null, name: "" },
      endItem: { id: null, name: "" },
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      allRooms: [],
      created_from: getInputDate(),
      created_to: getInputDate(),
      orderBy: "desc",
      status: "DIJADWALKAN",
      kamar_ranap_kelas: "",
      kamar_ranap_nama: "",
      columns: [
        {
          label: "No",
          field: "number",
        },
        { label: "No Rawat", field: "no_rawat" },
        { label: "Masuk pada", field: "masuk" },
        {
          label: "No. RM",
          field: "pasien.no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "pasien.nama" },
        { label: "Kamar", field: "kamar_ranap.nama" },
        { label: "Nomor Kasur", field: "kamar_ranap.formatted_no_kasur" },
        { label: "Kelas", field: "kamar_ranap.formatted_kelas" },
        // {label: 'Keluar pada', representedAs:(item)=> `${item.status=='SELESAI'?item.keluar:''}`},
        {
          label: "",
          class: "dropdown",
          representedAs: (
            item
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/ranap/detail/${item.id}?fromTab=${item.fromTab}"><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/ranap/detail/${item.id}?fromTab=${item.fromTab}">
                        <i class="material-symbols-outlined">open_in_new</i>
                        Detail Ranap
                    </a>
                    <a class="dropdown-item" href="/#/ranap/form-petugas/${item.id}?fromTab=${item.fromTab}" >
                        <i class="material-symbols-outlined">add</i>
                        Input Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ranap/form-dokter/${item.id}?fromTab=${item.fromTab}" >
                        <i class="material-symbols-outlined">add</i>
                        Input Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ranap/form-tindakan/${item.id}?fromTab=${item.fromTab}" >
                        <i class="material-symbols-outlined">add</i>
                        Input Tindakan
                    </a>
                    <a class="dropdown-item" href="/#/ranap/form-tagihan/${item.id}?fromTab=${item.fromTab}" >
                        <i class="material-symbols-outlined">add</i>
                        Input Tagihan
                    </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('cancel${item.id}').click()" >
                        <i class="material-symbols-outlined">cancel</i>Batalkan Rawat Inap
                    </a>
                </div>`,
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      totalData: 0,
      rows: [],
    };
  },
  methods: {
    endChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(e.target.name);
      //console.log(this[e.target.name])
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      this.form = this.form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self[column.name]
          ) {
            //console.log(self[column.name]);
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          if (self[column.name]) {
            column.value = String(self[column.name]);
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    async filterTab(filter) {
      //console.log(filter);
      this["status"] = filter;
      if (filter == "SELESAI") {
        this.columns = [
          {
            label: "No",
            field: "number",
          },
          { label: "No Rawat", field: "no_rawat" },
          { label: "Masuk pada", field: "masuk" },
          {
            label: "No. RM",
            field: "pasien.no_rm",
            headerClass: "class-in-header second-class",
          },
          { label: "Pasien", field: "pasien.nama" },
          { label: "Kamar", field: "kamar_ranap.nama" },
          { label: "Nomor Kasur", field: "kamar_ranap.formatted_no_kasur" },
          { label: "Kelas", field: "kamar_ranap.formatted_kelas" },
          {
            label: "Keluar pada",
            representedAs: (item) =>
              `${item.status == "SELESAI" ? item.keluar : ""}`,
          },
          {
            label: "",
            class: "dropdown",
            representedAs: (
              item
            ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/ranap/detail/${item.id}?fromTab=${item.fromTab}"><i class="material-symbols-outlined">open_in_new</i></a>
          <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
              <i class="material-symbols-outlined">apps</i>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
          <a class="dropdown-item" href="/#/ranap/detail/${item.id}?fromTab=${item.fromTab}">
              <i class="material-symbols-outlined">open_in_new</i>
              Detail Ranap
          </a>
          <a class="dropdown-item" href="/#/ranap/form-petugas/${item.id}?fromTab=${item.fromTab}" >
              <i class="material-symbols-outlined">add</i>
              Input Pemeriksaan Perawat
          </a>
          <a class="dropdown-item" href="/#/ranap/form-dokter/${item.id}?fromTab=${item.fromTab}" >
              <i class="material-symbols-outlined">add</i>
              Input Pemeriksaan Dokter
          </a>
          <a class="dropdown-item" href="/#/ranap/form-tindakan/${item.id}?fromTab=${item.fromTab}" >
              <i class="material-symbols-outlined">add</i>
              Input Tindakan
          </a>
          <a class="dropdown-item" href="/#/ranap/form-tagihan/${item.id}?fromTab=${item.fromTab}" >
              <i class="material-symbols-outlined">add</i>
              Input Tagihan
          </a>
      </div>`,
            interpolate: true,
          },
        ];
      } else {
        let action;
        if (filter == "DIJADWALKAN") {
          action = function(data) {
            return `<a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('cancel${data.id}').click()" >
                <i class="material-symbols-outlined">cancel</i>Batalkan Rawat Inap
            </a>`;
          };
        } else {
          action = function(data) {
            return `<a class="dropdown-item" data-toggle="modal" onclick="document.getElementById('end${data.id}').click()" >
                <i class="material-symbols-outlined">done_all</i>Rawat Inap Selesai
            </a>`;
          };
        }
        this.columns = [
          {
            label: "No",
            field: "number",
          },
          { label: "No Rawat", field: "no_rawat" },
          { label: "Masuk pada", field: "masuk" },
          {
            label: "No. RM",
            field: "pasien.no_rm",
            headerClass: "class-in-header second-class",
          },
          { label: "Pasien", field: "pasien.nama" },
          { label: "Kamar", field: "kamar_ranap.nama" },
          { label: "Nomor Kasur", field: "kamar_ranap.formatted_no_kasur" },
          { label: "Kelas", field: "kamar_ranap.formatted_kelas" },
          {
            label: "",
            class: "dropdown",
            representedAs: (
              item
            ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/ranap/detail/${
              item.id
            }"><i class="material-symbols-outlined">open_in_new</i></a>
          <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
              <i class="material-symbols-outlined">apps</i>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
              <a class="dropdown-item" href="/#/ranap/detail/${
                item.id
              }?fromTab=${item.fromTab}">
                  <i class="material-symbols-outlined">open_in_new</i>
                  Detail Ranap
              </a>
              <a class="dropdown-item" href="/#/ranap/form-petugas/${
                item.id
              }?fromTab=${item.fromTab}" >
                  <i class="material-symbols-outlined">add</i>
                  Input Pemeriksaan Perawat
              </a>
              <a class="dropdown-item" href="/#/ranap/form-dokter/${
                item.id
              }?fromTab=${item.fromTab}" >
                  <i class="material-symbols-outlined">add</i>
                  Input Pemeriksaan Dokter
              </a>
              <a class="dropdown-item" href="/#/ranap/form-tindakan/${
                item.id
              }?fromTab=${item.fromTab}" >
                  <i class="material-symbols-outlined">add</i>
                  Input Tindakan
              </a>
              <a class="dropdown-item" href="/#/ranap/form-tagihan/${
                item.id
              }?fromTab=${item.fromTab}" >
                  <i class="material-symbols-outlined">add</i>
                  Input Tagihan
              </a>
              ${action(item)}
          </div>`,
            interpolate: true,
          },
        ];
      }
      await this.displayList();
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      if (e.target.name == "kamar_ranap_kelas") {
        if (e.target.value) {
          this.filters.columns[3].value = "";
          this.filters.columns[3].options = this.allRooms.filter((item) => {
            return item.kelas == e.target.value;
          });
        } else {
          this.filters.columns[3].options = this.allRooms;
        }
      }
      await this.displayList();
    },
    displayList: async function() {
      // this.page = 1;
      this.loaded = false;
      this.errors = [];
      this.data.actionBtn[0].link = `${this.plainUrl}?fromTab=${this.status}`;
      try {
        let params = `?per_page=${this.perPage}&page=${this.page}`;
        if (this["filter"]) {
          params += `&cari_rawat=${this.filter}`;
        }
        if (this.status) {
          params += `&status=${this.status}`;
        }
        // created from and created to filter
        if (this.created_from) {
          params += `&created_from=${this.created_from}`;
        } else {
          params += `&created_from=null`;
        }
        if (this.created_to) {
          params += `&created_to=${this.created_to}`;
        } else {
          params += `&created_to=null`;
        }
        // created from and created to filter
        if (this.kamar_ranap_kelas) {
          params += `&kamar_ranap_kelas=${this.kamar_ranap_kelas}`;
        }
        if (this.kamar_ranap_nama) {
          params += `&kamar_ranap_nama=${this.kamar_ranap_nama}`;
        }
        if (this.orderBy) {
          params += `&orderBy=${this.orderBy}`;
        }
        let result = await this.$store.state.HTTP.get(`ranap${params}`);
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          //console.log("berhasil");
          this.rows = result.data.data.map((item, index) => {
            item.masuk =
              item.formatted_tgl_masuk + " " + item.formatted_jam_masuk;
            item.keluar =
              item.formatted_tgl_keluar + " " + item.formatted_jam_keluar;
            item.number =
              ((self.page || 1) - 1) * (self.perPage || 10) + index + 1;
            item.fromTab = self.status;
            return item;
          });
          //console.log(this.rows);
          this.totalData = result.data.total;
          //console.log(this.totalData);
          this.loaded = true;
          if (this.rows && this.rows.length) {
            // this.$nextTick(() => {
            //   if (this.$refs.focusMe) {
            //     this.$refs.focusMe.focus();
            //   }
            // });
          }
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    cancel: async function(id, name) {
      this.cancelItem = {
        id: id,
        name: name,
      };
    },
    async confirmCancel(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.post(
        `ranap/${id}`,
        `status=DIBATALKAN`
      );
      //console.log(result);
      if (result.status == 200) {
        this.cancelSuccess = true;
        await this.displayList();
      } else {
        this.cancelFailed = true;
      }
      this.resetAlert();
    },
    end: async function(id, name) {
      this.endItem = {
        id: id,
        name: name,
      };
      this.$bvModal.show("modalEnd");
    },
    async confirmEnd(id) {
      //console.log(id);
      let valid = this.validateForm();
      let self = this;
      if (valid) {
        let params = `status=SELESAI&tgl_keluar=${this.tgl_keluar}&jam_keluar=${this.jam_keluar}&cara_keluar=${this.cara_keluar}&keadaan_keluar=${this.keadaan_keluar}&dgs_keluar=${this.dgs_keluar}&prognosa=${this.prognosa}`;
        //console.log(params);
        let result = await this.$store.state.HTTP.post(`ranap/${id}`, params);
        //console.log(result);
        if (result.status == 200) {
          this.endSuccess = true;
          await this.displayList();
        } else {
          this.endFailed = true;
        }
        this.resetAlert();
        this.$bvModal.hide("modalEnd");
        this.form = this.form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (["dgs_keluar", "prognosa"].indexOf(column.name) > -1) {
              column.value = "";
              self[column.name] = "";
            } else if (column.name == "cara_keluar") {
              column.value = "Diijinkan Pulang";
              self[column.name] = column.value;
            } else if (column.name == "keadaan_keluar") {
              column.value = "Sembuh";
              self[column.name] = column.value;
            }
            return column;
          });
          return row;
        });
      }
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.endSuccess = false;
        self.cancelFailed = false;
        self.endFailed = false;
      }, 5000);
    },
    async goToPage(e) {
      // //console.log(e.target.innerHTML);
      let trg = e.target;
      // //console.log(trg);
      let char = trg.innerHTML;
      let disabled = trg.classList.contains("disabled");
      if (!disabled) {
        if (["‹", "›"].indexOf(char) < 0) {
          this.page = parseInt(char);
        }
      }
      await this.displayList();
    },
  },
  watch: {
    async perPage(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    async filter(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    // page(newData,oldData){
    //   // if(newData!=oldData){
    //   await this.displayList();
    //   // }
    // }
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.plainUrl = this.data.actionBtn[0].link.split("?")[0];
    let result = await this.$store.state.HTTP.get(
      "ranap/fasilitas/kamar?per_page=9999999999"
    );
    //console.log(result);
    this.allRooms = result.data.data.map((item) => {
      //console.log(item);
      item.label = item.nama;
      item.value = item.nama;
      return item;
    });
    this.filters.columns[3].options = this.allRooms;
    if (this.$route.query.tab) {
      this.status = this.$route.query.tab;
    }
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
